import { lazy } from "react";

import Paths from "./Paths";

import { PublicShortcut } from "../pages/PShortcut";
import { PublicControl } from "../pages/PControl";

const NotFoundLazy = lazy(() => import('../pages/NotFound/NotFound'));

const HomeLazy = lazy(() => import('../pages/Home'));
const SignInLazy = lazy(() => import('../pages/SignIn'));
const SignUpLazy = lazy(() => import('../pages/SignUp'));
const MyAccountLazy = lazy(() => import('../pages/Account/MyAccount'));
const PublicHomePageLazy = lazy(() => import('../pages/Home/PublicHomePage/PublicHomePage'));
const LivestreamLazy = lazy(() => import('../pages/Livestream/Livestream'));
const SysLazy = lazy(() => import('../pages/Sys/Sys'));


const DeviceDashboardLazy = lazy(() => import('../pages/Device/DeviceDashboard/DeviceDashboard'));
const DeviceFileLazy = lazy(() => import('../pages/Device/DeviceFile/DeviceFile'));
const DevicePlaylistsLazy = lazy(() => import('../pages/Device/DevicePlaylists/DevicePlaylists'));
const DeviceLiveLazy = lazy(() => import('../pages/Device/DeviceLive/DeviceLive'));
const DeviceBroadcastsLazy = lazy(() => import('../pages/Device/DeviceBroadcasts/DeviceBroadcasts'));
const DeviceStreamerLazy = lazy(() => import('../pages/Device/DeviceStreamer/DeviceStreamer'));
const DeviceStreamChannelsLazy = lazy(() => import('../pages/Device/DeviceStreamChannels/DeviceStreamChannels'));
const DeviceReports = lazy(() => import('../pages/Device/DeviceReports/DeviceReports'));

const NodeDashboardLazy = lazy(() => import('../pages/Node/NodeDashboard/NodeDashboard'));
const NodeTVLazy = lazy(() => import('../pages/Node/NodeTV/NodeTV'));
const NodeLiveLazy = lazy(() => import('../pages/Node/NodeLive/NodeLive'));
const NodeStreamerLazy = lazy(() => import('../pages/Node/NodeStreamer/NodeStreamer'));
const NodeBroadcastsLazy = lazy(() => import('../pages/Node/NodeBroadcasts/NodeBroadcasts'));
const NodeInfoLazy = lazy(() => import('../pages/Node/NodeInfo/NodeInfo'));
const NodeSettingsLazy = lazy(() => import('../pages/Node/NodeSettings/NodeSettings'));
const NodeTimersLazy = lazy(() => import('../pages/Node/NodeTimers/NodeTimers'));
const NodeControlLazy = lazy(() => import('../pages/Node/NodeControl/NodeControl'));
const NodeCloudStationsLazy = lazy(() => import('../pages/Node/NodeCloudStations/NodeCloudStations'));
const NodeCloudStationDetailLazy = lazy(() => import('../pages/Node/NodeCloudStationDetail/NodeCloudStationDetail'));
const NodeCloudWorkerLazy = lazy(() => import('../pages/Node/NodeCloudWorker/NodeCloudWorker'));
const CloudStationSharingPageLazy = lazy(() => import('../pages/CloudStationSharing/CloudStationSharingPage'));

const ChildAgencyLazy = lazy(() => import('../pages/Agency/ChildAgency/ChildAgency'));
const UserAgencyLazy = lazy(() => import('../pages/Agency/UserAgency/UserAgency'));
const UserGroupAgencyLazy = lazy(() => import('../pages/Agency/UserGroupAgency/UserGroupAgency'));
const AgencyLazy = lazy(() => import('../pages/Agency/Agency'));

const PlaylistViewerLazy = lazy(() => import('../pages/Playlist/Playlist'));

const AQIHomeLazy = lazy(() => import('../AQI/src/pages/Home/Home'));
const AQIDetailLazy = lazy(() => import('../AQI/src/pages/DetailDashboard/DetailDashboard'));

const RoutesConfig = [
  {
    path: Paths.NOTFOUND,
    element: NotFoundLazy,
  },

  {
    path: Paths.HOME,
    element: HomeLazy,
  },
  {
    path: Paths.LOGIN,
    element: SignInLazy,
  },
  {
    path: Paths.SIGNUP,
    element: SignUpLazy,
  },
  {
    path: Paths.MY_ACCOUNT,
    element: MyAccountLazy,
  },
  {
    path: Paths.MAP,
    element: PublicHomePageLazy,
  },
  {
    path: Paths.LIVESTREAM,
    element: LivestreamLazy,
  },
  {
    path: Paths.SYS,
    element: SysLazy,
  },



  {
    path: Paths.DEVICE_DASHBOARD,
    element: DeviceDashboardLazy,
  },
  {
    path: Paths.DEVICE_FILE,
    element: DeviceFileLazy,
  },
  {
    path: Paths.DEVICE_PLAYLISTS,
    element: DevicePlaylistsLazy,
  },
  {
    path: Paths.DEVICE_LIVE,
    element: DeviceLiveLazy,
  },
  {
    path: Paths.DEVICE_BROADCASTS,
    element: DeviceBroadcastsLazy,
  },
  {
    path: Paths.DEVICE_STREAMER,
    element: DeviceStreamerLazy,
  },
  {
    path: Paths.DEVICE_STREAM_CHANNELS,
    element: DeviceStreamChannelsLazy,
  },
  {
    path: Paths.DEVICE_REPORTS,
    element: DeviceReports,
  },

  {
    path: Paths.NODE_DASHBOARD,
    element: NodeDashboardLazy,
  },
  {
    path: Paths.NODE_TV,
    element: NodeTVLazy,
  },
  {
    path: Paths.NODE_LIVE,
    element: NodeLiveLazy,
  },
  {
    path: Paths.NODE_STREAMER,
    element: NodeStreamerLazy,
  },
  {
    path: Paths.NODE_BROADCASTS,
    element: NodeBroadcastsLazy,
  },
  {
    path: Paths.NODE_INFO,
    element: NodeInfoLazy,
  },
  {
    path: Paths.NODE_TIMER,
    element: NodeTimersLazy,
  },
  {
    path: Paths.NODE_SETTING,
    element: NodeSettingsLazy,
  },
  {
    path: Paths.NODE_CONTROL,
    element: NodeControlLazy,
  },
  {
    path: Paths.NODE_CLOUD_STATIONS,
    element: NodeCloudStationsLazy,
  },
  {
    path: Paths.NODE_CLOUD_STATION_DETAIL,
    element: NodeCloudStationDetailLazy,
  },
  {
    path: Paths.NODE_CLOUD_WORKER,
    element: NodeCloudWorkerLazy,
  },
  {
    path: Paths.CLOUD_STATION_SHARING,
    element: CloudStationSharingPageLazy,
  },

  
  {
    path: Paths.PUBLIC_SHORTCUT,
    element: PublicShortcut,
  },
  {
    path: Paths.PUBLIC_CONTROL,
    element: PublicControl,
  },


  {
    path: Paths.CHILD_AGENCY_HOME,
    element: ChildAgencyLazy,
  },
  {
    path: Paths.CHILD_AGENCY_USERS,
    element: UserAgencyLazy,
  },
  {
    path: Paths.AGENCY,
    element: AgencyLazy,
  },
  {
    path: Paths.CHILD_AGENCY_USER_GROUPS,
    element: UserGroupAgencyLazy,
  },

  {
    path: Paths.PLAYLIST_VIEWER,
    element: PlaylistViewerLazy,
  },

  {
    path: Paths.AQI_HOME,
    element: AQIHomeLazy,
  },
  {
    path: Paths.AQI_DETAIL,
    element: AQIDetailLazy,
  },
  {
    path: Paths.AQI_DETAIL_SLUG,
    element: AQIDetailLazy,
  },
];

export default RoutesConfig;